import { MicrophoneOffIcon } from './MicrophoneOffIcon';

/**
 * author: Google
 * id 90AD0141-2243-49F0-8B84-FF909244D237
 * name microphone-off
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/microphone-off.svg
 * tags
 * - Music 
 */
export const MicOffIcon = MicrophoneOffIcon;
export default MicOffIcon